module.exports = __webpack_public_path__ + "static/media/model-sorento-xm09.54d3daa6.webp";